<template>
  <v-row class="chips-row">
    <v-chip-group column>
      <v-chip
        v-for="(content, i) in linkedContent"
        :key="content.id"
        :href="getUrlContent(i)"
        target="_blank"
        class="light-background primary--text text--lighten-1"
      >
        <v-icon left class="primary--text text--lighten-1" v-if="fileExtensions[i] === 'pdf'" size="16">mdi-file-document-outline</v-icon>
        <v-icon left class="primary--text text--lighten-1" v-else-if="suporttedImageTypes.includes(fileExtensions[i])" size="16">mdi-file-image-outline</v-icon>
        <span>{{ getTextTranslation(content.title) }}</span>
        <v-icon right class="primary--text text--lighten-1" v-if="!!content.url" size="16">mdi-arrow-right</v-icon>
      </v-chip>
    </v-chip-group>
  </v-row>
</template>
<script>
import { getTextValue } from '@/lib/helpers/LocalizedText'
import { URL_PDF_VIEWER } from '@/config/environment'
import { ServiceRequests } from '@/services/service.requests'

const serviceService = new ServiceRequests()

export default {
  data () {
    return {
      suporttedImageTypes: ['jpg', 'jpeg', 'png', 'webp', 'gif'],
      fileExtensions: [],
    }
  },
  props: {
    linkedContent: {
      type: Array,
      default: [],
    },
  },
  created () {
    this.getFilesExtension(this.linkedContent)
  },
  methods: {
    getUrlContent (index) {
      const fileUrl = this.fileExtensions[index] === 'pdf' ? `${ URL_PDF_VIEWER }${ this.linkedContent[index].file }` : this.linkedContent[index].file
      const contentUrl = this.linkedContent[index].url && this.linkedContent[index].authenticated ? `${ this.linkedContent[index].url }?x-api-key=${ this.authToken }` : this.linkedContent[index].url
      return contentUrl ? contentUrl : fileUrl
    },
    getTextTranslation (LocalizedText) {
      return getTextValue(LocalizedText)
    },
    getFilesExtension (linkedContent) {
      const nullPromise = new Promise((resolve, reject) => resolve(null))
      const promises = linkedContent.map(({ fileId }) => fileId ? serviceService.getTypePublicFile(fileId) : nullPromise)
      Promise.all(promises).then((fileTypes) => {
        fileTypes.forEach((fileType, i) => {
          const extension = fileType ? fileType.split('/')[1] : null
          this.$set(this.fileExtensions, i, extension)
        })
      })
    },
  },
}
</script>
<style scoped>
.chips-row {
  padding: 5px 12px 5px;
}

span {
  color: var(--v-primary-lighten1);
  font-family: Mukta Mahee;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
</style>